import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from '@angular/router';
import { FarmService } from 'src/app/services/farm-service.service';
import { PhameeService } from 'src/app/services/phamee.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilService } from 'src/app/services/utils.service';
import { MouseEvent } from '@agm/core';
declare const $:any;

@Component({
  selector: 'smart-manage-farm-edit',
  templateUrl: './manage-farm-edit.component.html',
  styleUrls: ['./manage-farm-edit.component.scss','../../platform-color/platform-color.css']
})
export class ManageFarmEditComponent implements OnInit {
  form: FormGroup;
  template: any = sessionStorage.getItem('template');
  markers: marker[] = [];
  AllPlot: any[] = [];
  polygons: any[] = [];
  zoom: number = 18;
  datenow: any;
  
  // initial center position for the map
  lat: number = 13.764913;
  lng: number = 100.538283;
  loadFarm: boolean = false;
  loadMap: boolean = false;
  loadSearchBar: boolean = false;
  loadPolygon: boolean = false;
  submitted: boolean = false;
  confirmDeleteBtn: boolean = false;

  id: string;
  name: string;
  systemRole: string;
  delete_id: string;
  delete_zone_id: string;
  totalPlot: number;

  farmDetail = null;

  successModal: string = '#successModal';
  errorModal: string = '#errorModal';
  deleteModal: string = '#deleteModal';
  successDelModal: string = '#successDelModal';
  warningModal: string = '#warningModal';

  errorMessage: string = 'กรุณาลองใหม่อีกครั้ง';
  provinces = [];
  districts = [];
  subdistricts = [];
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private UtilService: UtilService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private location: Location,
    private farmService: FarmService,
    private phameeService: PhameeService,
    
    private cd: ChangeDetectorRef,
    private ngZone: NgZone
  ) { 
    this.id = this.route.snapshot.paramMap.get("id");
    this.name = this.route.snapshot.paramMap.get("name");
    this.totalPlot = this.UtilService.totalplot;
  }

  ngOnInit() {
    this.UtilService.getProvinces().subscribe(res=>{
      this.provinces = res.data.sort((a, b) => a.name_th > b.name_th ? 1 : -1) || [];

      this.reset();
    });

    this.systemRole = sessionStorage.getItem('system_role');
    this.spinner.show();
    this.createForm();
    this.valueChange();

    this.getDatenow();

    setTimeout(() => {
      this.getFarmByname(this.name);
      this.getPlots(this.id);
    }, 1000);
  }


  valueChange(){
    this.form.controls.province_code.valueChanges.subscribe(
      (value) => {

        if(value != this.form.value['province_code']){
      
          let findProvince = this.provinces.find(province => province.code == value);

          if(findProvince){
            this.form.get('province_id').setValue(findProvince.id);
            this.form.get('province_name_th').setValue(findProvince.name_th);

            this.UtilService.getDistricts(findProvince.id).subscribe(res=>{
              this.districts = res.data.sort((a, b) => a.name_th > b.name_th ? 1 : -1) || [];

              if(this.farmDetail.district.code && this.loadFarm == false){
                this.form.get('district_code').setValue(this.farmDetail.district.code);
              }
              this.reset();
            });
          }

          this.form.get('district_code').setValue("");
          this.form.get('district_id').setValue("");
          this.form.get('district_name_th').setValue("");

          this.form.get('subdistrict_code').setValue("");
          this.form.get('subdistrict_id').setValue("");
          this.form.get('subdistrict_name_th').setValue("");

        }
      }
    );

    this.form.controls.district_code.valueChanges.subscribe(
      (value) => {
       if(value != this.form.value['district_code']){
        let findDistrict = this.districts.find(district => district.code == value);

        if(findDistrict){
          this.form.get('district_id').setValue(findDistrict.id);
          this.form.get('district_name_th').setValue(findDistrict.name_th);

          this.UtilService.getSubDistricts(findDistrict.id).subscribe(res=>{
            this.subdistricts = res.data.sort((a, b) => a.name_th > b.name_th ? 1 : -1) || [];

            if(this.farmDetail.subdistrict.code && this.loadFarm == false){
              this.form.get('subdistrict_code').setValue(this.farmDetail.subdistrict.code);

              this.loadFarm = true;
            }
            this.reset();
          });
        }


        this.form.get('subdistrict_code').setValue("");
        this.form.get('subdistrict_id').setValue("");
        this.form.get('subdistrict_name_th').setValue("");
       }
      }
    );

    this.form.controls.subdistrict_code.valueChanges.subscribe(
      (value) => {

        if(value != this.form.value['subdistrict_code']){
          let findSubdistrict = this.subdistricts.find(subdistrict => subdistrict.code == value);

          if(findSubdistrict){
            this.form.get('subdistrict_id').setValue(findSubdistrict.id);
            this.form.get('subdistrict_name_th').setValue(findSubdistrict.name_th);
          }
        }
      }
    );
  }

  coordinateChanged(){

    let { lat, lon } = this.form.getRawValue();

    this.markers = [];
    this.markers.push({
      lat: parseFloat(lat),
      lng: parseFloat(lon),
      draggable: true,
      icon: 'assets/img/marker.png'
    });


    this.lat = parseFloat(lat);
    this.lng = parseFloat(lon);
    this.reset();
  }

  createForm(){
    this.form = this.formBuilder.group({
      name: ["", [Validators.required, Validators.pattern(/[\S]/g)]],
      desc: [""],
      addr1:  [""],
      lat: ["", [Validators.required]],
      lon: ["", [Validators.required]],
      zoom_lv: [18],
      subdistrict_id: [""],
      subdistrict_code: ["", [Validators.required]],
      subdistrict_name_th: [""],
      district_id: [""],
      district_code: ["", [Validators.required]],
      district_name_th: [""],
      province_id: [""],
      province_code: ["", [Validators.required]],
      province_name_th: [""],
    })
  }

  getDatenow() {
    const eventNow = new Date();
    const optionsNow = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    this.datenow = eventNow.toLocaleDateString('th-TH', optionsNow);
  }
  
  getPlots(farmId) {
  this.phameeService.getPlotDashboard(farmId)
    .subscribe(success => {
      if (success.code == 200) {
        this.AllPlot = success.data.plot;

        for (let i = 0; i < this.AllPlot.length; i++) {
          const element = this.AllPlot[i];
          Object.assign(element,{widget_sensor : []})

          if (element.thing.length > 0) {
            for (let j = 0; j < element.thing.length; j++) {
              const elementThing = element.thing[j];
              if (elementThing.sensor.length > 0) {
                elementThing.sensor.forEach(sensor => {
                  if(!['camera', 'video', 'image_capture'].includes(sensor.type)){

                    element.widget_sensor.push(sensor)
                  }
                });
              }
            }
          }
        }
        this.loadMap = true;
        this.spinner.hide();

        this.reset();
      }else{
        this.AllPlot = [];
        
        this.loadMap = true;
        this.spinner.hide();

        this.reset();
      }
    });
  }

  getFarmByname(name){
    if(name){
      this.farmService.getFarmByName(name).subscribe(success => {
        if (success.code == 200) {
          this.farmDetail = success.data[0];

          this.lat = this.farmDetail.coordinates['center'].lat;
          this.lng = this.farmDetail.coordinates['center'].lon;
          this.zoom = this.farmDetail.coordinates['center'].zoom_lv;

          this.markers.push({
            lat: this.lat,
            lng: this.lng,
            draggable: true,
            icon: 'assets/img/marker.png'
          });

          let data = {
            name: this.farmDetail.name,
            desc: this.farmDetail.desc,
            addr1: this.farmDetail.addr1,
            lat: this.farmDetail.coordinates['center'].lat,
            lon: this.farmDetail.coordinates['center'].lon,
            zoom_lv: this.farmDetail.coordinates['center'].zoom_lv,
            province_code: this.farmDetail.province.code,
            province_name_th: this.farmDetail.province.name_th,
          }

          this.form.patchValue(data);

          this.reset();
        }
      });
    }
  }

  reset(){
    this.cd.detectChanges();
  }

  zoomChange(zoom_lv){
    this.form.get('zoom_lv').setValue(zoom_lv);
  }

  mapClicked($event: MouseEvent) {
    this.markers = [];
    this.markers.push({
      lat: $event.coords.lat,
      lng: $event.coords.lng,
      draggable: true,
      icon: 'assets/img/marker.png'
    });

    this.form.get('lat').setValue(parseFloat($event.coords.lat.toFixed(6)));
    this.form.get('lon').setValue(parseFloat($event.coords.lng.toFixed(6)));
  }

  clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`)
  }
  
  markerDragEnd(m: marker, $event: MouseEvent) {
    console.log('dragEnd', m, $event);

    this.form.get('lat').setValue(parseFloat($event.coords.lat.toFixed(6)));
    this.form.get('lon').setValue(parseFloat($event.coords.lng.toFixed(6)));
  }

  mapReady(map) {
    map.setOptions({
      zoomControl: "true",
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      draggable: true
    });

    const search = document.getElementById("search") as HTMLElement;

    map.controls[google.maps.ControlPosition.TOP_LEFT].push(search);

    const input = document.getElementById("search-input") as HTMLInputElement;

    const defaultBounds = {
      north: this.lat + 0.1,
      south: this.lat - 0.1,
      east: this.lng + 0.1,
      west: this.lng - 0.1,
    };

    const options = {
      bounds: defaultBounds,
      componentRestrictions: { country: "th" },
      fields: ["address_components", "geometry", "icon", "name"],
      strictBounds: false,
      types: ["establishment"],
    };
  
    const autocomplete = new google.maps.places.Autocomplete(input, options);
  
    // Set initial restriction to the greater list of countries.
    autocomplete.setComponentRestrictions({
      country: ["th"],
    });

    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        //get the place result
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();

        //verify result
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        //set latitude, longitude and zoom
        this.lat = place.geometry.location.lat();
        this.lng = place.geometry.location.lng();
        this.zoom = 18;

        this.reset();
      });
    });

    setTimeout(() => {
      this.loadSearchBar = true;
      this.reset();
    }, 1000);

    for (let i = 0; i < this.AllPlot.length; i++) {
      let polygons = [];
      const element = this.AllPlot[i];
      if(element.coordinates.map_polygon.length > 0){
        for (let j = 0; j < element.coordinates.map_polygon.length; j++) {
          const elementPolygon = element.coordinates.map_polygon[j];

          polygons.push(
            new google.maps.LatLng(elementPolygon.lat, elementPolygon.lon),
          )
        }
      }
        
      this.polygons.push(
        { polygons: polygons, color: element.zone.color || 'red' }
      )
    }
    this.loadPolygon = true;
    this.reset();
  }

  get f() {
    return this.form.controls;
  }

  save(){
    this.submitted = true;
    if (this.form.invalid) {
      return;
    };

    let form = this.form.value;
    let data = {
      farm_id: this.id,
      org_id: sessionStorage.getItem('Org'),
      child_org_id: sessionStorage.getItem('ChildOrg'),
      name: form.name,
      active: true,
      desc: form.desc,
      addr1: form.addr1,
      addr2: null,
      subdistrict: {
        code: form.subdistrict_code,
        name_th: form.subdistrict_name_th,
      },
      district: {
        code: form.district_code,
        name_th: form.district_name_th,
      },
      province: {
        code: form.province_code,
        name_th: form.province_name_th,
      },
      coordinates: {
        center: {
            lat: form.lat,
            lon: form.lon,
            zoom_lv: form.zoom_lv
        }
      }
    };

    this.farmService.updateFarm(data).subscribe(res=>{
      if(res.code == 200){
        $(`${this.successModal}`).modal("show");
      }else{
        if(res.message == 'Data existed'){
          this.errorMessage = 'ชื่อฟาร์มของท่านมีอยู่แล้ว กรุณาลองใหม่อีกครั้ง';

          this.reset();
          $(`${this.errorModal}`).modal("show");
        }else{
          this.errorMessage = 'กรุณาลองใหม่อีกครั้ง';

          this.reset();
          $(`${this.errorModal}`).modal("show");
        }
      }
    })
  }

  back(): void {
    this.getMenu("back");
  }

  async getMenu(url = "current"){
    await this.phameeService.getPlotMenu(sessionStorage.getItem('ChildOrg'))
    .subscribe(response => {
      let arrMenu = [];
      if (response.code == 200) {
        arrMenu = response.data    
        sessionStorage.setItem("menufarm", JSON.stringify(arrMenu));
        if(url == "current"){
          window.location.reload();
        }else{
          this.router.navigate(["/manage-farm"]).then(() => {
            window.location.reload();
          });
        }
      }
    });
  }

  delete(plot){
    this.delete_id = plot.id;
    this.delete_zone_id = plot.zone_id;
    $(`${this.deleteModal}`).modal("show");
  }

  addPlot(){
    if(this.AllPlot.length >= this.totalPlot){
      $(`${this.warningModal}`).modal("show");
    }else{

      this.router.navigate([`/manage-farm/${this.id}/${this.name}/plot/createPlot`]);
    }
  }

  delPlot(){
    this.farmService.deletePlot(this.delete_id).subscribe(async res=>{
      this.farmService.deleteZone(this.delete_zone_id).subscribe(zone=>{
        $(`${this.deleteModal}`).modal("hide");

        $(`${this.successDelModal}`).modal("show");
      });
    })
  }

  openGooglemap(){
    let url =   "https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination="+this.farmDetail.coordinates.center.lat+ ","+this.farmDetail.coordinates.center.lon;
    window.open(url, '_blank');
  }
}


interface marker {
	lat: number;
	lng: number;
	label?: string;
	draggable: boolean;
  icon?: string;
}